import { render, staticRenderFns } from "./couponStatistics.vue?vue&type=template&id=0280970a"
import script from "./couponStatistics.vue?vue&type=script&lang=js"
export * from "./couponStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports